import React, { useState } from 'react';
import { useField } from 'informed';
import { useTranslation } from 'react-i18next';

import OtpInputController from '../OtpInput/OtpInput';
import { customToast } from '../ToastUtils/ToastUtils';

interface InputFieldProps {
  field: string;
  label: string;
  validationSchemaObject: any;
  touched: boolean;
  error: string;
  disabled?: boolean;
  apiStatus?: number;
  labelStyles?: string;
  otpContainerStyles?: string;
  inputClassName?: string;
  inputFocusClassName?: string;
  errorClassName?: string;
  errorMessageStyles?: string;
  numInputs?: number;
  onHandleChange?: (value: string) => void;
}

export const InformedOTPFieldWithBoxes = React.memo(
  (props: InputFieldProps) => {
    const { t } = useTranslation();
    const {
      validationSchemaObject,
      field,
      touched,
      error,
      disabled,
      apiStatus,
      labelStyles,
      label,
      otpContainerStyles,
      inputClassName,
      inputFocusClassName,
      errorClassName,
      errorMessageStyles,
      numInputs,
      onHandleChange,
    } = props;

    const { fieldState, render, informed } = useField({
      field,
      validationSchema: validationSchemaObject.fields[field],
      error: error,
      touched: touched,
    });
    const { value } = fieldState;
    const { onChange, onBlur } = informed;
    const isNotValid = touched && error ? true : false;

    const [isFocus, setFocus] = useState(true);

    const showToast = () => {
      customToast(t('common.pleaseEnterNumbers'));
    };

    const onBlurOTP = (e) => {
      onBlur(e);
      setFocus(false);
    };

    const onChangeOTP = (otp) => {
      onChange(otp);
      setFocus(true);
      onHandleChange && onHandleChange(otp);
    };

    return render(
      <OtpInputController
        onChange={(value) => {
          onChangeOTP(value);
        }}
        otpValue={value as string}
        isError={Boolean(error) || isNotValid}
        label={label}
        errorMessage={error}
        shouldAutoFocus={true}
        showToast={showToast}
        isDisabled={disabled}
        inputClassName={inputClassName}
        inputFocusClassName={inputFocusClassName}
        errorClassName={errorClassName}
        t={t}
        apiStatus={apiStatus}
        labelStyles={labelStyles}
        otpContainerStyles={otpContainerStyles}
        errorMessageStyles={errorMessageStyles}
        numInputs={numInputs}
        onBlur={onBlurOTP}
        isFocus={isFocus}
      />,
    );
  },
);
